module.exports = __webpack_public_path__ + "img/Rating.ad546275.png";